import type { Pregunta } from '../types/content'

export const preguntas: Pregunta[] = [
  {
    pregunta: '¿Cómo recibo el sistema después de comprar?',
    respuesta:
      'Recibís acceso inmediato a los 11 archivos PDF apenas se confirma el pago. Sin esperas, sin aplicaciones y desde cualquier dispositivo. La descarga es instantánea.',
  },
  {
    pregunta: '¿El pago es único o es una suscripción?',
    respuesta:
      'Es un pago único. No hay suscripción, no hay renovaciones y no se cobra nada de forma automática. Pagás una vez y el material queda tuyo para siempre.',
  },
  {
    pregunta: '¿Puedo comprarlo desde mi país?',
    respuesta:
      'Sí. El sistema está pensado para toda LATAM: Argentina, México, Colombia, Perú y Chile, entre otros. La plataforma convierte el precio a tu moneda local automáticamente.',
  },
  {
    pregunta: '¿El contenido es editable? ¿Puedo ponerle mi marca?',
    respuesta:
      'Sí. Los PDF son editables: podés poner tu nombre, tu logo, tu número de WhatsApp y tus precios específicos. Es tuyo para usar como lo necesites.',
  },
  {
    pregunta: '¿Funciona si trabajo desde casa?',
    respuesta:
      'Totalmente. Los protocolos, scripts y precios se adaptan a manicura a domicilio, salón pequeño, estética o local grande.',
  },
  {
    pregunta: '¿Sirve si no tengo mucha experiencia?',
    respuesta:
      'Sí. Cada tomo está escrito paso a paso, con checklists y ejemplos. Podés empezar por el Tomo 1 e implementar cambios en 24 horas.',
  },
  {
    pregunta: '¿Es un curso con videos o certificación?',
    respuesta:
      'No. Es un sistema digital de aplicación inmediata en PDF. No incluye clases en video, coaching ni certificación académica.',
  },
  {
    pregunta: '¿Qué pasa si no me sirve?',
    respuesta:
      'Tenés 7 días para revisarlo. Si no es lo que esperabas, te devolvemos el 100% de tu inversión. Sin preguntas, sin formularios largos y sin vueltas.',
  },
]
